module.exports = __webpack_public_path__ + "f41fc050a08be4d1230f6137a3249e26.pdf";